import React from 'react';
import { useNavigate } from 'react-router-dom';
import mapIcon from '../assets/android/ui/p4r_map_view.svg';
import feedIcon from '../assets/android/ui/p4r_feed_view.svg';
import './FeedMapSwitch.css';

export default function FeedMapSwitch({ showingMap = false, disabled = false }) {
  const navigate = useNavigate();
  const destination = showingMap ? '/feed' : '/map';
  return (
    <button
      type="button"
      className="p4r-feed-map-switch"
      onClick={() => !disabled && navigate(destination)}
      disabled={disabled}
      aria-label={showingMap ? 'Open Feed' : 'Open Map'}
      title={showingMap ? 'Open Feed' : 'Open Map'}
    >
      <img src={showingMap ? feedIcon : mapIcon} alt="" />
    </button>
  );
}
